export const DEFAULT_SEARCH_FIELD_LOADING_ID = "DEFAULT_SEARCH_FIELD_LOADING_ID";
export const METAFIELD_SEARCH_FIELD_LOADING_ID = "METAFIELD_SEARCH_FIELD_LOADING_ID";
export const VARIANT_METAFIELD_SEARCH_FIELD_LOADING_ID = "VARIANT_METAFIELD_SEARCH_FIELD_LOADING_ID";
